import { useLoadReward } from "hooks";
import { PBV3RewardClaimStatus, PoisBountyProgressStep } from "interfaces";

interface IUseRewards {
	steps: PoisBountyProgressStep[] | undefined;
}

export const useRewards = (data?: PBV3RewardClaimStatus[]): IUseRewards => {
	const { loadReward } = useLoadReward();

	const steps: PoisBountyProgressStep[] | undefined = data?.map((item) => {
		const { reward, isClaimed, claimed } = item;
		const { rewardId, loyaltyPoints } = reward;

		return {
			imageUrl: loadReward(rewardId)?.imageUrl,
			rewardAmount: loadReward(rewardId)?.numberOfItems,
			target: loyaltyPoints,
			claimedDate: claimed,
			status: isClaimed ? "unlocked" : "locked"
		};
	});

	return {
		steps
	};
};
